// tslint:disable:no-any

import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import MapPoint, { getMapProps } from '../components/MapPoint';
import { DEFAULT_MAP_ZOOM } from '../constants/MapVariables';

interface IDiveMapState {
    point: any;
    diveData: any;
    center: any;
    shared?: boolean;
}

export interface IDiveMapProps {
    diveData: any;
    point: any;
    center: any;
    zoom?: number;
    startupZoom?: number;
    shared?: boolean;
    onMapClick: (e: Event) => void;
}

export default class DiveMap extends React.Component<
    IDiveMapProps,
    IDiveMapState
> {
    constructor(props: IDiveMapProps) {
        super(props);
        this.state = {
            diveData: props.diveData,
            point: props.point,
            center: props.center,
            shared: props.shared
        };
    }

    componentWillReceiveProps(nextProps: IDiveMapProps) {
        const lat = Number.parseFloat(String(nextProps.point.lat).replace(',', '.'));
        const lng = Number.parseFloat(String(nextProps.point.lng).replace(',', '.'));

        if (!Number.isNaN(Number(lat)) || !Number.isNaN(Number(lng))) {
            return;
        }

        this.setState({
            diveData: nextProps.diveData,
            point: { lat, lng },
        });
    }

    render() {
        const lat = Number.parseFloat(String(this.state.point.lat).replace(',', '.'));
        const lng = Number.parseFloat(String(this.state.point.lng).replace(',', '.'));

        const validCoordinates = this.state.point
            && !Number.isNaN(lat)
            && !Number.isNaN(lng);

        if (!validCoordinates) {
            return null;
        }

        const mapProps = getMapProps([this.state.diveData]);

        return (
            <div className="map">
                <GoogleMapReact
                    resetBoundsOnResize={true}
                    bootstrapURLKeys={{
                        key: (window as any).__REACT_SETTINGS.googleMapsApiKey
                    }}
                    center={mapProps.center}
                    zoom={DEFAULT_MAP_ZOOM}
                    onClick={(e: any) => this.props.onMapClick(e as any)}
                >
                    <MapPoint
                        display={true}
                        shared={
                            this.state.shared !== undefined
                                ? this.state.shared
                                : false
                        }
                        lat={lat}
                        lng={lng}
                    />
                </GoogleMapReact>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveMap.tsx